import {
  VendorUserType,
  selectVendorUser,
} from "auth/VendorAuth/vendorUserSlice";
import ElementContainer, {
  ReadOnlyElementContainer,
} from "components/elements/ElementContainer";
import { useAppSelector } from "hooks/redux";
import { filter, sortBy } from "lodash";
import { selectRfi } from "store/rfiSlice";
import { VendorResponseState, selectVendorResponse } from "store/vendorResponseSlice";
import RfiElement from "types/RfiElement";
import "../../styles/rfiElements.css";
import { ElementAnswer, SectionGroup, sectionNames } from "../../types/RfiTypes";
import { vendorNavPages } from "./VendorNav";
import axios from "axios";
import ErrorModal from "components/ErrorModal";
import { useEffect, useState } from "react";
import ConfirmModal from "components/ConfirmModal";
import useConfirmModal from "hooks/useConfirmModal";
import { ConfirmModalProps } from "store/confirmModalSlice";
import { Console } from "console";

interface IRfiVendorAllProps {
  user?: VendorUserType;
  section?: string;
  setSelectedPage: (page: number) => void;
  readOnly?: boolean;
}

const RenderSection = (props: IRfiVendorAllProps) => {
  // Hooks
  const rfi = useAppSelector(selectRfi);
  const vendorResponse = useAppSelector(selectVendorResponse);
  const vendorUser = useAppSelector(selectVendorUser);
  const { open } = useConfirmModal()

  const [showSamButton, setShowSamButton] = useState(props.readOnly ? !props.readOnly : false)
  const [showSamErrorModal, setShowSamErrorModal] = useState(false)
  const [samErrorTitle, setSamErrorTitle] = useState<string>("SAM Error")
  const [samErrorDescription, setSamErrorDescription] = useState<string>("")
  const [elements, setElements] = useState<RfiElement[] | any[]>([])

  useEffect(() => {
    let el: RfiElement[] | null = [];
    switch (props.section) {
      case sectionNames.DESCRIBE:
        el = rfi.describe;
        setShowSamButton(false)
        break;
      case sectionNames.VENDOR_INFO:
        el = rfi.vendorInfo;
        setShowSamButton(props.readOnly ? !props.readOnly : true)
        break;
      case sectionNames.QUESTIONNAIRE:
        el = rfi.questionnaire;
        setShowSamButton(false)
        break;
      default:
        break;
    }

    const page3 = filter(el, (e: RfiElement) => {
      const eSections = e.sections?.find((s: SectionGroup) => {
        return s.sectionGroupName === props.section;
      });
  
      return eSections?.sectionGroupName === props.section;
    });

    var result = sortBy(page3, (element) => {
      return element.sections?.find(
        (x: SectionGroup) => x.sectionGroupName === props.section
      )?.sequence;
    });

    setElements(result)
  }, [props.section])

  const HandlePullFromSamClicked = (vendorInfo : RfiElement[] | null, rfiId : number | undefined) => {
    //get uei value
    let ueiValue = ""
    let ueiElement = rfi.vendorInfo?.find((element) => element.mapsToField === "VENDOR_UEI");
    if (ueiElement && ueiElement.answers && ueiElement.answers.length > 0) {
      ueiValue = ueiElement.answers[0].value ? ueiElement.answers[0].value : ""
    }
    
    if (ueiValue === "") {
      setSamErrorDescription("Valid UEI is required in order to retrieve data from SAM.")
      setShowSamErrorModal(true)
    }
    else {
      getSamData(ueiValue, rfiId)
    }
  }
  
  const getSamData = async (uei:string, rfiId:number | undefined) => {
    try {
      await axios
        .get(`/api/v1/rfi/${rfiId}/vendorresponses/${uei}/samData`)
        .then((res) => {
          if (res?.data) {
            showConfirmModal(uei, res.data)
            //alert(JSON.stringify(res.data))
          }
          else {
            setSamErrorDescription("UEI was not found. Valid UEI is required in order to retrieve data from SAM.")
            setShowSamErrorModal(true)
            //alert("UEI was not found. Valid UEI is required in order to retrieve data from SAM.")
          }
        })
        .catch((error:any) => {
          setSamErrorDescription("UEI was not found. Valid UEI is required in order to retrieve data from SAM.")
          setShowSamErrorModal(true)
          console.log(error);
        })
      
    } catch {
      console.error("Error fetching SAM data");
    }
  }

  const showConfirmModal = async (uei:string, samData:any) => {
    const isConfirmed = await open({
      title: "Retrieve SAM Data",
      message: "The RFI Assistant shall retrieve SAM data for " + uei + " - " + samData.legaL_BUSINESS_NAME + ". Would you like to continue? Any data existing in the SAM-associated fields on this page will be overwritten with the data from SAM.",
      description: "Confirm get SAM data",
      confirmText: "Yes",
      cancelText: "No",
    } as ConfirmModalProps)

    if (isConfirmed) {
      setElements((prevElements) => {
        const updatedElements = prevElements.map((element:RfiElement) => {
          let field = element.mapsToField?.toUpperCase() || ""
          switch (field) {
            case "VENDOR_CAGE":
              field = "CAGE_CODE"
              break
            case "VENDOR_LEGAL_NAME":
              field = "LEGAL_BUSINESS_NAME"
              break
            case "VENDOR_PRIMARY_NAICS":
              field = "PRIMARY_NAICS"
              break
          }
          console.log(field)
          const matchingKey = Object.keys(samData).find((key) => key.toUpperCase() === field)
          if (matchingKey) {
            console.log(matchingKey)
            if (element.answers && element.answers.length > 0) {
              const updatedAnswers = element.answers.map((answer:ElementAnswer) => ({
                ...answer,
                value: samData[matchingKey]
              }))

              return {...element, answers: updatedAnswers}
            }
            else {
              return {
                ...element,
                answers: [{
                  value: samData[matchingKey]
                }]
              }
            }
          }

          return element
        })

        return updatedElements
      })
    }
  }

  // Render
  if (elements.length === 0) {
    return (
      <p className="guidance-text">There is no questionnaire for this RFI.</p>
    )
  }
  else return (
    <>
     {showSamButton && <div className="row">
       <div className="col d-flex justify-content-end mb-3">
       <button className="btn btn-primary m-1" role="button" onClick={() => HandlePullFromSamClicked(elements, rfi.rfi?.rfiId)}>Pull from SAM</button>
      </div>
      </div>}
            
      {elements.map((element: RfiElement, i: number) => {
        let questionNumber = element.sections?.find(
          (x: SectionGroup) => x.sectionGroupName === props.section
        )?.questionNumber;
        // console.log("key:", i);
        // console.log("element info:", element);
        // console.log("question number:", questionNumber);
        if (
          !props.user ||
          !props.user.isAuthenticated ||
          props.readOnly ||
          (vendorResponse.vendorResponse?.vendorResponseId ?? 0) === 0
        ) {
          return (
            <ReadOnlyElementContainer
              key={i}
              element={element}
              questionNumber={questionNumber}
              readOnly
              showValue={props.user && props.user.isAuthenticated ? true : false}
            />
          );
        } else {
          return (
            <ElementContainer
              key={i}
              element={element}
              questionNumber={questionNumber}
              defaultValue={
                element.mapsToField === "NOTIFICATION_EMAIL" ? vendorUser.email : ""
              }
            />
          );
        }
      })}
      <ErrorModal
      show={showSamErrorModal}
      handleClose={() => setShowSamErrorModal(false)}
      title={samErrorTitle}
      description={samErrorDescription}
      children={samErrorDescription}
      />
    </>
  );
};


const VendorRfiQuestionnaire = (props: IRfiVendorAllProps) => {
  // Hooks
  const rfi = useAppSelector(selectRfi);
  const vendorResponse = useAppSelector(selectVendorResponse);

  // State
  let questionNumber: number = 0;

  // Render
  return (
    <>
      <div className="rfi-content">
        {props.section ? (
          <RenderSection {...props} />
        ) : (
          <>
            <h1>Questionnaire</h1>
            <div className="k-ml-5">
              <RenderSection section={sectionNames.VENDOR_INFO} {...props} />
              <RenderSection section={sectionNames.QUESTIONNAIRE} {...props} />
            </div>
          </>
        )}

        {props.user?.isAuthenticated &&
          (vendorResponse.vendorResponse?.vendorResponseId ?? 0) > 0 &&
          props.setSelectedPage &&
          props.section === `${sectionNames.VENDOR_INFO}` && (
            <div className="mt-5">
              <button
                className="btn btn-primary m-1"
                role="button"
                onClick={() => props.setSelectedPage(vendorNavPages.AUTH_DETAILS)}
              >
                <i className="fa-solid fa-chevron-left"></i> RFI Package
              </button>
              <button
                className="btn btn-primary m-1"
                role="button"
                onClick={() =>
                  props.setSelectedPage(vendorNavPages.QUESTIONNAIRE)
                }
              >
                Step 2: Questionnaire{" "}
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </div>
          )}
        {props.user?.isAuthenticated &&
          (vendorResponse.vendorResponse?.vendorResponseId ?? 0) > 0 &&
          props.setSelectedPage &&
          props.section === `${sectionNames.QUESTIONNAIRE}` && (
            <div className="mt-5">
              <button
                className="btn btn-primary m-1"
                role="button"
                onClick={() => props.setSelectedPage(vendorNavPages.VENDOR_INFO)}
              >
                <i className="fa-solid fa-chevron-left"></i> Step 1: Update Vendor
                Information
              </button>
              <button
                className="btn btn-primary m-1"
                role="button"
                onClick={() => props.setSelectedPage(vendorNavPages.ATTACHMENTS)}
              >
                Step 3: Additional Attachments{" "}
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </div>
          )}
        {props.user &&
          (!props.user.isAuthenticated ||
            (vendorResponse.vendorResponse?.vendorResponseId ?? 0) === 0) && (
            <div className="mt-5">
              <button
                className="btn btn-primary m-1"
                role="button"
                onClick={() =>
                  props.setSelectedPage(vendorNavPages.UNAUTH_ATTACHMENTS)
                }
              >
                <i className="fa-solid fa-chevron-left"></i> Attachments
              </button>
              <button
                className="btn btn-primary m-1"
                role="button"
                onClick={() => props.setSelectedPage(vendorNavPages.QA)}
              >
                Q&A <i className="fa-solid fa-chevron-right"></i>
              </button>
            </div>
          )}
      </div>
    </>
  );
};

export default VendorRfiQuestionnaire;
